interface SectionTitleProps {
  label: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionTitle({ label, title, desc, align = 'left' }: SectionTitleProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <div className={`flex flex-col ${alignment}`}>
      <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">
        <span className="h-1 w-6 rounded-full bg-primary-500"></span>
        {label}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 ${align === 'center' ? 'mx-auto' : ''}`}>
          {desc}
        </p>
      )}
    </div>
  );
}